import React from 'react';
import { Check, Star } from 'lucide-react';

const Pricing = () => {
  const plans = [
    {
      name: 'Day Pass',
      price: '500',
      description: 'Drop in for a day and experience our coworking space',
      features: [
        'Single day access',
        'High-speed WiFi',
        'Access to amenities',
        'Complimentary tea & coffee'
      ],
      popular: false
    },
    {
      name: 'Hot Desk',
      price: '6,000',
      description: 'Flexible seating option perfect for freelancers and part-time workers',
      features: [
        'Flexible seating',
        'High-speed WiFi',
        'Access to amenities',
        'Community events',
        'Printing credits'
      ],
      popular: false
    },
    {
      name: 'Dedicated Desk',
      price: '6,500',
      description: 'Your own permanent desk in our collaborative workspace',
      features: [
        'Fixed dedicated desk',
        'High-speed WiFi and LAN',
        'Meeting room access',
        'Mail handling',
        'All amenities included'
      ],
      popular: true
    },
    {
      name: '2 Seater Cabin',
      price: '20,000',
      description: 'Private cabin for duo teams and small partnerships',
      features: [
        'Private lockable cabin',
        'High-speed WiFi and LAN',
        'Meeting room access',
        'Mail handling',
        'All amenities included'
      ],
      popular: false
    },
    {
      name: '4 Seater Cabin',
      price: '36,000',
      description: 'Spacious cabin ideal for growing teams and startups',
      features: [
        'Private lockable cabin',
        'High-speed WiFi and LAN',
        'Customizable space',
        'Meeting room access',
        'Priority support',
        'All amenities included'
      ],
      popular: false
    },
    {
      name: '6 Seater Cabin',
      price: '48,000',
      description: 'Large private cabin for established teams and businesses',
      features: [
        'Private lockable cabin',
        'High-speed WiFi and LAN',
        'Customizable space',
        'Dedicated phone line',
        'Priority meeting rooms',
        'Premium support'
      ],
      popular: false
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '16px', color: 'var(--brand-primary)' }}>
          FLEXIBLE PRICING PLANS
        </h2>
        <p className="pricing-tagline" style={{ textAlign: 'center', marginBottom: '8px' }}>
          Premium Coworking. Exceptional Value.
        </p>
        <p className="body-medium" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-secondary)' }}>
          Choose the perfect plan for your needs
        </p>

        <div className="pricing-grid">
          {plans.map((plan, index) => {
            const isOrange = index % 2 === 0;
            return (
              <div key={index} className={`pricing-card ${isOrange ? 'card-orange' : 'card-blue'}`}>
                {plan.popular && (
                  <div className="popular-badge">
                    <Star size={16} style={{ marginRight: '6px' }} />
                    MOST POPULAR
                  </div>
                )}
                
                <h3 className="heading-4" style={{ marginBottom: '12px' }}>{plan.name}</h3>
                <p className="body-small" style={{ marginBottom: '8px', minHeight: '45px' }}>{plan.description}</p>
                
                <div style={{ marginTop: '-12px', paddingTop: '0px' }}>
                  <div className="price">
                    <span className="price-currency">₹</span>
                    <span className="price-amount">{plan.price}</span>
                    <span className="price-period">{plan.name === 'Day Pass' ? '/day' : '/month'}</span>
                  </div>
                  <p className="price-gst">plus GST</p>
                </div>

                <ul className="features-list">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="feature-item">
                      <Check size={18} style={{ color: isOrange ? 'var(--brand-primary)' : 'var(--brand-secondary)', marginRight: '8px', flexShrink: 0, marginTop: '3px' }} />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <button onClick={scrollToContact} className={isOrange ? 'btn-card-orange' : 'btn-card-blue'}>
                  GET STARTED
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
